import React from "react";
import PropTypes from 'prop-types';
import ModalV4 from "../../../../app/ui/modal/v4/v4";

import CRMSearchHeader from "./components/header/header";
import CRMSearchList from "./components/list/list";

const debug = false
// const debug = "ModalCRMSearch"

class ModalCRMSearch extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            type        : PropTypes.oneOf(['remove-contact', 'contact', 'account']),
            accountId   : PropTypes.string,
            contactIds  : PropTypes.array,
            onSubmit    : PropTypes.func
        })
    }

    constructor(props) {
        super(props);

        this.state = {
            search: '',
            currentCursorKey: null
        }

        this.options = [];

        this.resetData();
    }

    componentDidMount() {
        //timeout for focus because shortcut appeared in it right away
        if (this.header) setTimeout(()=>{this.header.focusInput()}, 0);
    }

    resetData = () => {
        let models;
        switch (this.props.params.type) {
            case 'remove-contact'   :
                const contactIdsToRemove = _.isEmpty(this.props.params.contactIds) ? [] : this.props.params.contactIds;
                // get contacts for passed contactIds only
                models = _(gd.session.crmContacts.models)
                    .filter(model => contactIdsToRemove.includes(model.id))
                    .value();
                break

            case 'contact':
                const accountId = _.isEmpty(this.props.params.accountId) ? null : this.props.params.accountId;
                const contactIds = _.isEmpty(this.props.params.contactIds) ? [] : this.props.params.contactIds;

                debug && console.log(debug, 'resetData contactIds', contactIds, this.props.params.contactIds)

                // filter out contactIds and contacts with accountId not matching accountId if present
                models = _(gd.session.crmContacts.models)
                    .filter(model => !contactIds.includes(model.id) && !(accountId && model.crmAccountId !== accountId))
                    .value();
                break;

            case 'account':
                models = gd.session.crmAccounts.models;
                break;
        }

        this.items = _.orderBy(models,model=>model.name.toLowerCase());

        debug && console.log(debug, 'resetData', this.items)

        this._updateOptions();
    }

    _updateOptions = () => {
        this.options = this.items.map(v=>v.id);
    }

    _getCurrentOptionKey = () => {
        return !_.isNil(this.state.currentCursorKey) ? this.options[this.state.currentCursorKey] : null;
    }

    onSearchChange = (event) => {
        const value = event.target.value ? event.target.value : '';
        const search = value ? value.trim().toLowerCase() : '';

        this.resetData();

        if (search) {
            this.items = _.filter(this.items, model=>model.name.toLowerCase().includes(search));
            this._updateOptions();
        }

        this.setState({
            search: value
        })
    }

    onSearchCancel = () => {this.resetData(); this.setState({search: ''})}
    onClickOption = (id) => {
        this.closeModal();

        let accountId, contactIds;

        switch (this.props.params.type) {
            case 'remove-contact'   :
                // get account id of selected contact (not needed but just in case)
                accountId = gd.session.crmContacts.get(id).crmAccountId
                // pass contact id to remove
                contactIds = [id]
                break

            case 'contact':
                // get account id of selected contact
                accountId = gd.session.crmContacts.get(id).crmAccountId;
                // add contact id to passed contactIds
                contactIds = _.union(_.get(this.props, 'params.contactIds', []), [id]);
                break;

            case 'account':
                // set selected account id
                accountId = id;
                // clear contact ids
                contactIds = null;
                break;
        }

        this.props.params.onSubmit(accountId, contactIds);
    }

    onAddClick = () => {
        this.closeModal();

        switch (this.props.params.type) {
            case 'remove-contact'   : /*should never happen*/ break
            case 'contact'          : gd.openNew('crm', {type: 'contact'}); break
            case 'account'          : gd.openNew('crm', {type: 'account', onAddCallback: this.onClickOption}); break
        }
    }

    onPopoverKeyDown = (event) => {
        let newValue;
        switch(event.key) {
            case 'Escape': this.closeModal(); break;

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0;
                } else {
                    newValue = this.state.currentCursorKey - 1;
                    if (newValue < 0) newValue = 0;
                }

                this.setState({currentCursorKey: newValue});
                break;

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0;
                } else {
                    newValue = this.state.currentCursorKey + 1;
                    if (newValue > this.options.length - 1) newValue = this.options.length - 1;
                }

                this.setState({currentCursorKey: newValue});
                break;

            case 'Enter':
                const currentOptionKey = this._getCurrentOptionKey();
                if (currentOptionKey) this.onClickOption(currentOptionKey);
                break;
        }
    }

    render() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation} onKeyDown={this.onPopoverKeyDown}>
                <CRMSearchHeader ref={r=>this.header = r}
                                 type={this.props.params.type}
                                 search={this.state.search}
                                 onSearchChange={this.onSearchChange}
                                 onSearchCancel={this.onSearchCancel}
                                 onCloseModal={this.closeModal}/>
                <CRMSearchList type={this.props.params.type}
                               accountId={this.props.params.accountId}
                               items={this.items}
                               currentOptionKey={this._getCurrentOptionKey()}
                               onClickOption={this.onClickOption}
                               onAddClick={this.onAddClick}/>
            </div>
        )
    }
}

module.exports = ModalCRMSearch;